import React, { Component } from 'react'
import SimpleDataTable from '../../../../../../modules/SimpleDataTable';
import {configStatisticProspectToday} from '../config'
import { fetchDataAsync } from '../../../../../../Services/Utils';
import Api from '../../../../../../Services/Api';
import { HttpStatus } from '../../../../../common/Constants';
import * as R from 'ramda'
export default class ReportStatisticProspectToday extends Component {
  constructor(props){
    super(props);
    this.state = {
      dataTable: [],
    };
  }

  componentDidUpdate(prevProps, prevState) { 
    if(this.props.doSearch && !R.equals(prevProps.doSearch,this.props.doSearch)){
      this.fetchData()
    }
  } 

  fetchData = async () =>{
    try{
      this.props.triggerLoading()
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikToday,
        setError: this.props.setError,
        menuName: "Dashboard CRM Koordinator - Statistik Hari Ini",
        args: {
          kodeCabang: this.props.search.kodeCabang,
          teamLeaderEmployeeId: this.props.search?.teamLeader || null,
          salesId: null
        },
      });
      this.props.onSuccessSearch()
      if(res.ok && res.data.status === HttpStatus.SUCCESS){
        this.setState(prev=>({
          ...prev,
          dataTable: res.data.data
        }))
      }
      this.props.triggerLoading()
    }catch(e){
      this.props.triggerLoading()
      this.props.onSuccessSearch()
      console.log(e)
    }
  }

  render() {
    return (
      <div style={{ padding: "10px" }}>
        <p style={{ fontWeight: "bold", marginBottom: "10px" }}>
          LAPORAN STATISTIK PROSPEK TODAY
        </p>
        <div style={{ width: "50vw" }}>
          <SimpleDataTable
            data={this.state.dataTable}
            columns={configStatisticProspectToday}
            rowsPerPage={5}
            page={0}
            options={{serverSide: false}}
          />
        </div>
      </div>
    );
  }
}
